/**
 測量 DOM 元素的高度，在元素高度變化時自動更新。
 返回 setter 函數來綁定目標 DOM，以及實時更新的高度值。
 */
import { useState, useEffect, useCallback } from 'react'

const useMeasureHeight = () => {
  const [height, setHeight] = useState(0)
  const [element, setElement] = useState(null)
  const measure = useCallback(() => {
    if (element) {
      const { height } = element.getBoundingClientRect()
      setHeight(height)
    }
  }, [element])

  useEffect(() => {
    if (!element) return

    // 初次測量高度
    measure()

    // 監聽 Resize 事件
    const resizeObserver = new ResizeObserver(() => {
      measure()
    })
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [element, measure])

  return [setElement, height]
}

export default useMeasureHeight
